import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/vhosts/dailyneedsworld.com/httpdocs/node_modules/next/dist/client/app-dir/link.js");
